/// TYPES ///
import { Counter } from "api/types/sketch";
import { Point } from "api/types/sketch";
import { Corner } from "api/types/sketch";
/// FUNCTIONS ///
import { createCorners } from "../create";
import { clockwise } from "../math";
import { getDistance } from "../math";
import { getDistantPoint } from "../math";

export function updateAngle(
  counter: Counter,
  point_uuid: string,
  relative_angle: number
): Counter {
  let delta_angle: number = 0;
  let angle_modified: boolean = false;

  const distances: number[] = [];
  const points: Point[] = [...counter.points];

  for (let j = 0; j < points.length - 1; j++) {
    const last_point: Point = points[j - 1];
    const point: Point = { ...points[j] };
    const next_point: Point = points[j + 1];
    distances.push(getDistance(point.location, next_point.location));

    if (j !== 0 && j !== points.length - 1 && point_uuid === point.uuid) {
      const is_clockwise: boolean = clockwise(last_point.angle, point.angle);
      const new_angle = is_clockwise ? last_point.angle + relative_angle : last_point.angle - relative_angle;
      delta_angle = new_angle - point.angle;
      angle_modified = true;
      point.angle = new_angle;
      points[j] = point;
      continue;
    }

    if (angle_modified) {
      point.angle = point.angle + delta_angle;
      points[j] = point;
    }
  }

  for (let j = 1; j < points.length; j++) {
    const last_point: Point = points[j - 1];
    const point: Point = { ...points[j] };
    point.location = getDistantPoint(last_point.location, last_point.angle, distances[j - 1]);
    points[j] = point;
  }

  const corners: Corner[] = createCorners(points, [...counter.corners], counter.uuid);

  return { ...counter, points: points, corners: corners };
}
